import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CilDashboardComponent } from 'src/app/CIL/cil-dashboard/cil-dashboard.component';
import { FiveSDashboardComponent } from 'src/app/CIL/five-s-dashboard/five-s-dashboard.component';
import { NewCilDashboardComponent } from 'src/app/CIL/new-cil-dashboard/new-cil-dashboard.component';
import { NewDefectDashboardComponent } from 'src/app/CIL/new-defect-dashboard/new-defect-dashboard.component';
import { DefectDashboardComponent } from 'src/app/DMS/defect-dashboard/defect-dashboard.component';
import { AuthGuard } from 'src/app/services/auth.guard';
import { DashboardComponent } from './dashboard.component';
import { DtParetoDashboardComponent } from './dt-pareto-dashboard/dt-pareto-dashboard.component';
import { GenealogyDashboardComponentVersion2 } from './genealogy-dashboard-version2/genealogy-dashboard-version2.component';
import { GenealogyDashboardComponent } from './genealogy-dashboard/genealogy-dashboard.component';
import { MaintenanceBoardComponent } from './maintenance-board/maintenance-board.component';
import { OeeDashboardComponent } from './oee-dashboard/oee-dashboard.component';
import { ProductionQualityDashboardComponent } from './production-quality-dashboard/production-quality-dashboard.component';
import { QuotidianDashboardComponent } from './quotidian-dashboard/quotidian-dashboard.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { EnergyDashboardComponent } from './energy-dashboard/energy-dashboard.component';
import { ParameterAnalysisDashboardComponent } from './parameter-analysis-dashboard/parameter-analysis-dashboard.component';
import { LiveDashboardComponent } from './live-dashboard/live-dashboard.component';


const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
  {
    path: 'Dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  { path: 'Maintenance', component: MaintenanceBoardComponent },
  { path: 'CIL', component: CilDashboardComponent },
  { path: 'OEE', component: OeeDashboardComponent },
  { path: 'ProductionQuality', component: ProductionQualityDashboardComponent },
  { path: 'quotidianOEE', component: QuotidianDashboardComponent },
  { path: 'Pareto', component: DtParetoDashboardComponent },
  { path: 'NewCILDashboard', component: NewCilDashboardComponent },
  { path: 'NewDefectDashboard', component: NewDefectDashboardComponent },
  { path: 'Five-S-Dashboard', component: FiveSDashboardComponent },
  { path: 'Genealogy', component: GenealogyDashboardComponent },
  { path: 'Genealogy-v2', component: GenealogyDashboardComponentVersion2 },
  { path: 'AdminDashboard', component: AdminDashboardComponent },
  { path: 'EnergyDashboard', component: EnergyDashboardComponent },
  { path: 'ParameterAnalysis', component: ParameterAnalysisDashboardComponent },
  { path: 'live', component: LiveDashboardComponent }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
